import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./styles/GlobalStyles";
import { theme } from "./styles/theme";
import StartPage from "./components/StartPage";
import MacbookPage from "./components/MacbookPage";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <div style={{ margin: "12rem 0rem 16rem 0rem" }}>
        <MacbookPage />
      </div>
      <hr style={{ margin: "8rem 0rem 8rem 0rem" }} />
      <div style={{ margin: "6rem 0rem 6rem 0rem" }}>
        <StartPage />
      </div>
    </ThemeProvider>
  );
}

export default App;
